import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { DocStatusEnum, TDocument } from '../types.ts';
import { WEB_DOCS } from '~/constants/docs.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import { updateDocsInFormAction } from '~/store/identification-form/slices.ts';
import { TIITHash } from '~/store/iit/types.ts';
import { selectIITHashes } from '~/store/iit/selectors.ts';

export const useDocumentsToSign = (documents: TDocument[]) => {
  const IITHashes = useSelector(selectIITHashes);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const newDocs: { [key: number]: number[] } = {};
    IITHashes.forEach((item: TIITHash) => {
      const key = Object.keys(WEB_DOCS).find((key) => item.fileNameToSign.includes(key));
      newDocs[WEB_DOCS[key as keyof typeof WEB_DOCS]] = [item.documentId];
    });
    dispatch(updateDocsInFormAction({ newDocuments: newDocs, deletedDocuments: {} }));
  }, [IITHashes]);

  const modifiedDocs = useMemo(
    () =>
      documents.reduce((acc: TDocument[], doc: TDocument) => {
        if (!doc.idDoc || doc.docStatus === DocStatusEnum.SUCCESS) return acc;
        const docName =
          Object.keys(WEB_DOCS).find(
            (document) => WEB_DOCS[document as keyof typeof WEB_DOCS] === doc.idDictWebDocument
          ) || '';

        if (IITHashes.some((item) => item.fileNameToSign.includes(docName))) {
          acc.push({ ...doc, docStatus: DocStatusEnum.NOT_VERIFIED });
        }
        return acc;
      }, []),
    [documents, IITHashes]
  );

  return modifiedDocs;
};

export default useDocumentsToSign;
